import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { format, formatDistance } from 'date-fns'
import { es } from 'date-fns/locale'

/** Tailwind className merger */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/** Formato de moneda USD */
export function fmtMoney(n: number | null | undefined): string {
  if (n == null) return '—'
  return `$${Number(n).toLocaleString('es-EC', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
}

/** Formato de monto compacto (ej $8.9k) */
export function fmtMoneyCompact(n: number | null | undefined): string {
  if (n == null) return '—'
  const abs = Math.abs(n)
  if (abs >= 1000) {
    return `$${(n / 1000).toFixed(abs >= 10000 ? 0 : 1)}k`
  }
  return `$${n.toFixed(2)}`
}

/** Formato de fecha con locale es */
export function fmtDate(d: string | Date | null): string {
  if (!d) return '—'
  try {
    return format(new Date(d), 'dd MMM yyyy', { locale: es })
  } catch {
    return String(d)
  }
}

export function fmtDateTime(d: string | Date | null): string {
  if (!d) return '—'
  try {
    return format(new Date(d), 'dd MMM HH:mm', { locale: es })
  } catch {
    return String(d)
  }
}

/** Tiempo relativo: "hace 2 min", "hace 1h" */
export function fmtRelative(d: string | Date | null): string {
  if (!d) return '—'
  try {
    return formatDistance(new Date(d), new Date(), { addSuffix: true, locale: es })
  } catch {
    return String(d)
  }
}

/** Formatea número grande con separador de miles */
export function fmtNumber(n: number | null | undefined): string {
  if (n == null) return '—'
  return Number(n).toLocaleString('es-EC')
}

/** Trunca string a N chars con elipsis */
export function truncate(s: string | null | undefined, max: number): string {
  if (!s) return ''
  return s.length > max ? s.slice(0, max - 1) + '…' : s
}

/** Normaliza número de WhatsApp a E.164 */
export function normalizePhone(raw: string): string {
  const digits = raw.replace(/\D/g, '')
  if (digits.startsWith('593')) return `+${digits}`
  if (digits.startsWith('09')) return `+593${digits.slice(1)}`
  if (digits.startsWith('9') && digits.length === 9) return `+593${digits}`
  return raw
}
